import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { ErrorPageComponent } from './views/pages/error-page/error-page.component';
import { HIGHLIGHT_OPTIONS } from 'ngx-highlightjs';
import { SplashScreenService } from "@copec-gid/gid-arquitectura.utilitarios-base-modulo-a16";
import { LayoutModule } from "@copec-gid/gid-arquitectura.tema-default-a16/left-light";
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './core/inicial-componente/app.component';
import { PageWaitComponent } from './core/inicial-componente/page-wait/page-wait.component';

//MODULO DE SEGURIDAD QUE PUEDE CAMBIAR
import { ConfProyecto } from '@copec-gid/gid-arquitectura.utilitarios-base-modulo-a16';
import { HTTPService } from '@copec-gid/gid-arquitectura.seguridad-autorizacion-modulo';

// Librerias solo para Monitor
import { AutenticacionGoogle, ConfAutentificacionGoogle } from '@copec-gid/monitor-mkt.autenticacion-monitor-modulo-a16'
import { ConfMonitor, AuthGuard, InterceptorService } from '@copec-gid/monitor-mkt.utilitarios-monitor-modulo';
import { GidLoggerModule } from '@copec-gid/gid-arquitectura.console-log';
import { environment } from 'src/environments/environment';
import { SIDENAV_CONFIG } from './config/menu-monitor.config';



function initSingletonHTTPService(
  httpService: HTTPService,
  autenticacionGoogle: AutenticacionGoogle,
  splash: SplashScreenService) {
  return () => {
    return new Promise(async (resolve: any) => {
      (window as any).splashGeneral = () => splash;
      HTTPService.instance = httpService

      //######## CONFIGURACION GENERAL DE LA APLICACION ########
      ConfProyecto.init({
        //TODO path que permitira la llamada que traera las rutas del sistema.
        //TODO modicar las urls que permitira la llamada que traera el menu, logout de la aplicacion, si se ingresan solo los path usuaria el proxy o dominio en el que corre.
        //TODO SE DEBE ACTUALIZAR EL ARCHIVO proxy.conf.json con el domimnio o url cloudfront si es que aun no se define dicho dominio
        // Puede modificar el nombre abreviado de la aplicacion, pathprincipal de navegacion y path del login principal
        urlMenu: undefined,
        urlLogOut: undefined,
        nombreAplicacion: "MMKT",
        pathPaginaPrincipal: "/principal",
        pathLogin: "/login",
        pathPerfil: undefined,
        //TODO debes moficiar la llave publica que se genero en KMS a levantar la infraestructura
        public_key: environment.public_key,
        application_id: 'monitor-mkt',
      });

      ConfMonitor.init({
        authTokenKey: environment.authTokenKey,
        userToken: '',
        sideNavMonitor: SIDENAV_CONFIG,
        bulkUploadMaxRows: {
          coupons: 150_001,
          segments: 700_001,
          subscriptionPoints: 500_001,
          reversePoints: 500_001
        }
         // Numero maximo de filas permitidas en carga masiva
      })
      //######## FIN CONFIGURACION GENERAL DE LA APLICACION ########

      //######## CONFIGURACION AUTENTIFICACION GOOGLE ########
      ConfAutentificacionGoogle.init({
        // TODO: path de las urls para la autenticacion de google, en el directorio raiz debe modificar el dominio en el archivo proxy.conf.json
        // el archivo proxy.conf.json solo funciona en npm start "local", en ambientes deployados asumira  el dominio.
        urlOAutSessionStep: "/api_login/session",  //Obtener las credenciales de sesión.
        urlOAutGoogleStep: "/api_login/googleauth",  //Login Google Monitor
        urlOAuthPermissionsStep: "/api_login/permisos", // Obtener los permisos disponible para cada usuario.
      });

      ConfProyecto.session_key = localStorage.getItem('session_key') || '';
      ConfProyecto.session_token = localStorage.getItem('session_token') || '';
      /**
      permite que al actualizar el navegador y siempre que el email este guardado en localstorage pueda recuperar la sesion
      Si no usuara el modulo de autenticacion de google debe comentar o eliminar la linea.
      */
      // await autenticacionGoogle.activeLoginGoogle(window.location.pathname + window.location.search)
      //######## FIN CONFIGURACIONES AUTENTIFICACIONES GOOGLE ###########

      resolve()
    });
  };
}

@NgModule({
  declarations: [
    AppComponent,
    ErrorPageComponent,
    PageWaitComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    LayoutModule,
    HttpClientModule,
    AppRoutingModule,
    GidLoggerModule.forRoot(environment)
  ],
  providers: [
    AuthGuard,
    SplashScreenService,
    HTTPService,
    AutenticacionGoogle,
    {
      provide: APP_INITIALIZER,
      useFactory: initSingletonHTTPService,
      multi: true,
      deps: [HTTPService, AutenticacionGoogle, SplashScreenService]
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true,
    },
    {
      provide: HIGHLIGHT_OPTIONS, // https://www.npmjs.com/package/ngx-highlightjs
      useValue: {
        coreLibraryLoader: () => import('highlight.js/lib/core'),
        languages: {
          xml: () => import('highlight.js/lib/languages/xml'),
          typescript: () => import('highlight.js/lib/languages/typescript'),
          scss: () => import('highlight.js/lib/languages/scss'),
        }
      }
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

}
